// GENERATED by the build: one lazy chunk per locale so a German player never
// downloads the Korean card text. Regenerate if locales are added.
export type LocaleFile = {
  locale: string;
  ui: Record<string, string>;
  cards: Record<string, { name?: string; bonus?: unknown; penalty?: unknown; action?: string }>;
};

export const LOCALE_LOADERS: Record<string, () => Promise<{ default: LocaleFile }>> = {
  "cz": () => import("@fr/carddata/i18n/cz"),
  "de": () => import("@fr/carddata/i18n/de"),
  "en-default": () => import("@fr/carddata/i18n/en-default"),
  "en": () => import("@fr/carddata/i18n/en"),
  "es": () => import("@fr/carddata/i18n/es"),
  "fr": () => import("@fr/carddata/i18n/fr"),
  "it": () => import("@fr/carddata/i18n/it"),
  "kr": () => import("@fr/carddata/i18n/kr"),
  "pl": () => import("@fr/carddata/i18n/pl"),
  "pt": () => import("@fr/carddata/i18n/pt"),
  "ru": () => import("@fr/carddata/i18n/ru"),
  "ua": () => import("@fr/carddata/i18n/ua"),
  "zh": () => import("@fr/carddata/i18n/zh"),
  "zh_TW": () => import("@fr/carddata/i18n/zh_TW"),
};

export const LOCALES = Object.keys(LOCALE_LOADERS);
